import {
  StonjiWheelIllustration_default
} from "./chunk-MR6CL32P.mjs";
import {
  StonjiWhiteHeartIllustration_default
} from "./chunk-XR3HUU6R.mjs";
import {
  StonjiWithoutAsteriscGreenIllustration_default
} from "./chunk-2FRSX7SZ.mjs";
import {
  StonjiWithoutAsteriscIllustration_default
} from "./chunk-L3D3T64G.mjs";
import {
  TabletIllustration_default
} from "./chunk-HAJMSVII.mjs";
import {
  TonLogoIllustration_default
} from "./chunk-YAYCWTMS.mjs";
import {
  TonLogoMobileIllustration_default
} from "./chunk-3FIB7TNT.mjs";
import {
  StonjiPhoneIllustration_default
} from "./chunk-XXWWTOXC.mjs";
import {
  StonjiPillarAppIllustration_default
} from "./chunk-XEKU2P5B.mjs";
import {
  StonjiPillarCallIllustration_default
} from "./chunk-SH5GQW26.mjs";
import {
  StonjiPillarIntegrationsIllustration_default
} from "./chunk-3GY6XOXY.mjs";
import {
  StonjiPillarJustIllustration_default
} from "./chunk-5GYVQJDX.mjs";
import {
  StonjiPixIllustration_default
} from "./chunk-2FXB7QMN.mjs";
import {
  StonjiShieldIllustration_default
} from "./chunk-QWE23MZT.mjs";
import {
  StonjiSmileIllustration_default
} from "./chunk-EJ2PYK7N.mjs";
import {
  StonjiMoneyBlackIllustration_default
} from "./chunk-XHA6CHST.mjs";
import {
  StonjiMoneyGreenIllustration_default
} from "./chunk-UN6UOAUW.mjs";
import {
  StonjiMoneyIllustration_default
} from "./chunk-AJ35YK3E.mjs";
import {
  StonjiPackageIllustration_default
} from "./chunk-TPJVFWTD.mjs";
import {
  StonjiPercentBlack_default
} from "./chunk-7ZYNUOLD.mjs";
import {
  StonjiPercentGreenIllustration_default
} from "./chunk-7ZF2Y5ER.mjs";
import {
  StonjiPercentIllustration_default
} from "./chunk-5AEDEGJU.mjs";
import {
  StonjiPhoneGreenIllustration_default
} from "./chunk-BRMUMISU.mjs";
import {
  StonjiChatIllustration_default
} from "./chunk-ILVFVNYD.mjs";
import {
  StonjiCheckGreenIllustration_default
} from "./chunk-FKLAWEEG.mjs";
import {
  StonjiCheckIllustration_default
} from "./chunk-CLMUIWZZ.mjs";
import {
  StonjiCreditCardFrontIllustration_default
} from "./chunk-B6EHEH6V.mjs";
import {
  StonjiCreditCardIllustration_default
} from "./chunk-CLIUDRD4.mjs";
import {
  StonjiDollarSignIllustration_default
} from "./chunk-XG2EP6XE.mjs";
import {
  StonjiFaceIllustration_default
} from "./chunk-YXWZP363.mjs";
import {
  StonjiLockIllustration_default
} from "./chunk-HW3HGSPF.mjs";
import {
  StoneLogoIllustration_default
} from "./chunk-EUB2YL7E.mjs";
import {
  StoneLogoMobileIllustration_default
} from "./chunk-SEJFDHG2.mjs";
import {
  StonjiAgentIllustration_default
} from "./chunk-QJ536IX7.mjs";
import {
  StonjiArrowUpIllustration_default
} from "./chunk-GRVT4GVD.mjs";
import {
  StonjiBarsIllustration_default
} from "./chunk-2G7EJR4D.mjs";
import {
  StonjiBoletoIllustration_default
} from "./chunk-BMVPNFMJ.mjs";
import {
  StonjiCardErrorIllustration_default
} from "./chunk-QWEXR5NQ.mjs";
import {
  StonjiChartBlackIllustration_default
} from "./chunk-F7IZGGYA.mjs";
import {
  PhoneIllustration_default
} from "./chunk-ANQXILML.mjs";
import {
  PixInLoteIllustration_default
} from "./chunk-46LHX5BU.mjs";
import {
  PosNfcIllustration_default
} from "./chunk-JCLAV4NU.mjs";
import {
  QrCodeSquareIllustration_default
} from "./chunk-ZX674WUD.mjs";
import {
  ShieldIllustration_default
} from "./chunk-ORAPY2OL.mjs";
import {
  SoftwaresIllustration_default
} from "./chunk-IGGUAZG4.mjs";
import {
  StoneCardGrayIllustration_default
} from "./chunk-SAWHQQJC.mjs";
import {
  StoneCardIllustration_default
} from "./chunk-W4WD6KMR.mjs";
import {
  JustStonjiIllustration_default
} from "./chunk-Y6R5A54U.mjs";
import {
  LinxLogoIllustration_default
} from "./chunk-BFLXULPT.mjs";
import {
  LinxLogoMobileIllustration_default
} from "./chunk-KJLGOTSK.mjs";
import {
  MachinePosIllustration_default
} from "./chunk-T4WWZZQP.mjs";
import {
  MachineTabletIllustration_default
} from "./chunk-M36K3U4K.mjs";
import {
  MailSuccessesIllustration_default
} from "./chunk-SIZL5PPE.mjs";
import {
  PackageIllustration_default
} from "./chunk-MFKJLSMR.mjs";
import {
  PercentGreenIllustration_default
} from "./chunk-ZI42GLUM.mjs";
import {
  GreenCheckIllustration_default
} from "./chunk-XJNPIMMF.mjs";
import {
  HandCardMachineIllustration_default
} from "./chunk-MZLIVSFW.mjs";
import {
  HandQrCodeIllustration_default
} from "./chunk-GPM6ASNE.mjs";
import {
  HandsUsingAppGray_default
} from "./chunk-QZ4GCBQA.mjs";
import {
  HandsUsingAppIllustration_default
} from "./chunk-RRZJXAKF.mjs";
import {
  HangLooseIllustration_default
} from "./chunk-CDVW3JKL.mjs";
import {
  HeadPhoneSoftIllustration_default
} from "./chunk-3E2CMGLX.mjs";
import {
  IntegrationsIllustration_default
} from "./chunk-5AK6ITQU.mjs";
import {
  CreditCardIllustration_default
} from "./chunk-3B3SP7FH.mjs";
import {
  DeliveryIllustration_default
} from "./chunk-QQLY7RR4.mjs";
import {
  DoubleCardsIllustration_default
} from "./chunk-A6HYWGXP.mjs";
import {
  EasyTurningGrayIllustration_default
} from "./chunk-ZWJNYZ45.mjs";
import {
  EasyTurningIllustration_default
} from "./chunk-AYHPTJPW.mjs";
import {
  FoneIllustration_default
} from "./chunk-2IG75FUZ.mjs";
import {
  FreeMachineIllustration_default
} from "./chunk-43A3YPWK.mjs";
import {
  Gift2XIllustration_default
} from "./chunk-JJGIRIZT.mjs";
import {
  BoletoIllustration_default
} from "./chunk-NLBXVZ6A.mjs";
import {
  CallIllustration_default
} from "./chunk-NRIZLK7Q.mjs";
import {
  CardErrorIllustration_default
} from "./chunk-DAUJ5HNS.mjs";
import {
  CoinGrayIllustration_default
} from "./chunk-QPTQVRF7.mjs";
import {
  CoinIllustration_default
} from "./chunk-IL5QSJFQ.mjs";
import {
  CoinStackIllustration_default
} from "./chunk-63VOW6AU.mjs";
import {
  CoinsIllustration_default
} from "./chunk-N3XVNJWF.mjs";
import {
  CoinsStackShineIllustration_default
} from "./chunk-VB74SYCT.mjs";
import {
  AnimationChatIllustration_default
} from "./chunk-Y6EKCSVK.mjs";
import {
  AnimationPhoneIllustration_default
} from "./chunk-U5YC62YM.mjs";
import {
  AnimationWhatsappIllustration_default
} from "./chunk-WEI2Z3SR.mjs";
import {
  AppIllustration_default
} from "./chunk-BVPJ2ZDW.mjs";
import {
  BlackCheckIllustration_default
} from "./chunk-TZSTZCX3.mjs";
import {
  BlackQrCodeIllustration_default
} from "./chunk-E6TCLJCC.mjs";
import {
  __export
} from "./chunk-7P6ASYW6.mjs";

// src/stone/illustrations/index.ts
var illustrations_exports = {};
__export(illustrations_exports, {
  animationChat: () => AnimationChatIllustration_default,
  animationPhone: () => AnimationPhoneIllustration_default,
  animationWhatsapp: () => AnimationWhatsappIllustration_default,
  app: () => AppIllustration_default,
  blackCheck: () => BlackCheckIllustration_default,
  blackQrCode: () => BlackQrCodeIllustration_default,
  boleto: () => BoletoIllustration_default,
  call: () => CallIllustration_default,
  cardError: () => CardErrorIllustration_default,
  coin: () => CoinIllustration_default,
  coinGray: () => CoinGrayIllustration_default,
  coinStack: () => CoinStackIllustration_default,
  coins: () => CoinsIllustration_default,
  coinsStackShine: () => CoinsStackShineIllustration_default,
  creditCard: () => CreditCardIllustration_default,
  delivery: () => DeliveryIllustration_default,
  doubleCards: () => DoubleCardsIllustration_default,
  easyTurning: () => EasyTurningIllustration_default,
  easyTurningGray: () => EasyTurningGrayIllustration_default,
  fone: () => FoneIllustration_default,
  freeMachine: () => FreeMachineIllustration_default,
  gift2X: () => Gift2XIllustration_default,
  greenCheck: () => GreenCheckIllustration_default,
  handCardMachine: () => HandCardMachineIllustration_default,
  handQrCode: () => HandQrCodeIllustration_default,
  handsUsingApp: () => HandsUsingAppIllustration_default,
  handsUsingAppGray: () => HandsUsingAppGray_default,
  hangLoose: () => HangLooseIllustration_default,
  headPhoneSoft: () => HeadPhoneSoftIllustration_default,
  integrations: () => IntegrationsIllustration_default,
  justStonji: () => JustStonjiIllustration_default,
  linxLogo: () => LinxLogoIllustration_default,
  linxLogoMobile: () => LinxLogoMobileIllustration_default,
  machinePos: () => MachinePosIllustration_default,
  machineTablet: () => MachineTabletIllustration_default,
  mailSuccesses: () => MailSuccessesIllustration_default,
  package: () => PackageIllustration_default,
  percentGreen: () => PercentGreenIllustration_default,
  phone: () => PhoneIllustration_default,
  pixInLote: () => PixInLoteIllustration_default,
  posNfc: () => PosNfcIllustration_default,
  qrCodeSquare: () => QrCodeSquareIllustration_default,
  shield: () => ShieldIllustration_default,
  softwares: () => SoftwaresIllustration_default,
  stoneCard: () => StoneCardIllustration_default,
  stoneCardGray: () => StoneCardGrayIllustration_default,
  stoneLogo: () => StoneLogoIllustration_default,
  stoneLogoMobile: () => StoneLogoMobileIllustration_default,
  stonjiAgent: () => StonjiAgentIllustration_default,
  stonjiArrowUp: () => StonjiArrowUpIllustration_default,
  stonjiBars: () => StonjiBarsIllustration_default,
  stonjiBoleto: () => StonjiBoletoIllustration_default,
  stonjiCardError: () => StonjiCardErrorIllustration_default,
  stonjiChartBlack: () => StonjiChartBlackIllustration_default,
  stonjiChat: () => StonjiChatIllustration_default,
  stonjiCheck: () => StonjiCheckIllustration_default,
  stonjiCheckGreen: () => StonjiCheckGreenIllustration_default,
  stonjiCreditCard: () => StonjiCreditCardIllustration_default,
  stonjiCreditCardFront: () => StonjiCreditCardFrontIllustration_default,
  stonjiDollarSign: () => StonjiDollarSignIllustration_default,
  stonjiFace: () => StonjiFaceIllustration_default,
  stonjiLock: () => StonjiLockIllustration_default,
  stonjiMoney: () => StonjiMoneyIllustration_default,
  stonjiMoneyBlack: () => StonjiMoneyBlackIllustration_default,
  stonjiMoneyGreen: () => StonjiMoneyGreenIllustration_default,
  stonjiPackage: () => StonjiPackageIllustration_default,
  stonjiPercent: () => StonjiPercentIllustration_default,
  stonjiPercentBlack: () => StonjiPercentBlack_default,
  stonjiPercentGreen: () => StonjiPercentGreenIllustration_default,
  stonjiPhone: () => StonjiPhoneIllustration_default,
  stonjiPhoneGreen: () => StonjiPhoneGreenIllustration_default,
  stonjiPillarApp: () => StonjiPillarAppIllustration_default,
  stonjiPillarCall: () => StonjiPillarCallIllustration_default,
  stonjiPillarIntegrations: () => StonjiPillarIntegrationsIllustration_default,
  stonjiPillarJust: () => StonjiPillarJustIllustration_default,
  stonjiPix: () => StonjiPixIllustration_default,
  stonjiShield: () => StonjiShieldIllustration_default,
  stonjiSmile: () => StonjiSmileIllustration_default,
  stonjiWheel: () => StonjiWheelIllustration_default,
  stonjiWhiteHeart: () => StonjiWhiteHeartIllustration_default,
  stonjiWithoutAsterisc: () => StonjiWithoutAsteriscIllustration_default,
  stonjiWithoutAsteriscGreen: () => StonjiWithoutAsteriscGreenIllustration_default,
  tablet: () => TabletIllustration_default,
  tonLogo: () => TonLogoIllustration_default,
  tonLogoMobile: () => TonLogoMobileIllustration_default
});

export {
  illustrations_exports
};
